import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { useAppStore } from '../store';

type Head = {
    title: string;
    description: string;
};

type PageElementProps = React.PropsWithChildren<{
    head?: Partial<Head>;
}>;

const PageElement = ({ children, head }: PageElementProps) => {
    const location = useLocation();
    const { pathname } = location;
    const authConfig = useAppStore.use.authConfig?.();

    /** Creating a Page title from the pathname. This is a temp solution! */
    const generateHeadTitle = (path?: string) => {
        if (path) {
            const titles = path.split('/').filter(Boolean);
            const transformStringArray = titles.map((title) => {
                const titleToUpperCase = title.charAt(0).toUpperCase() + title.slice(1);
                return titleToUpperCase.replace(/-/g, ' ');
            });
            return transformStringArray;
        }
        return [path];
    };

    return (
        <>
            <Helmet>
                <title>{head?.title && `${generateHeadTitle(head?.title).join(' - ')} - Watchlist Screening`}</title>
                <meta name='description' content={head?.description ?? 'A Mastercard app'} />
                <script defer>
                    {(() => {
                        const link = document.createElement('link');
                        link.rel = 'canonical';
                        link.href = `${authConfig?.oauth?.redirectSignIn}/${pathname}`;
                        document.head.appendChild(link);
                    })()}
                </script>
            </Helmet>
            {children}
        </>
    );
};

export default PageElement;
